
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/assistant",
      function () {
        return require("private-next-pages/assistant.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/assistant"])
      });
    }
  